import KratosRecovery from "../src/components/Authentication/Kratos/KratosRecovery";

export default function Recovery() {
  return <KratosRecovery />;
}
